const marker = '(optional)';

export type OptionalLabelEnabler =
  | undefined
  | boolean
  | (() => boolean | undefined);

export function optionalFieldLabel(
  label: string,
  condition?: OptionalLabelEnabler
) {
  const result = typeof condition === 'function' ? condition() : condition;
  // undefined means true
  const enabled = result === undefined ? true : result;

  return enabled ? `${label} ${marker}` : label;
}
